class BrewingGuide extends HTMLElement {
  connectedCallback() {
    window.addEventListener('load', this.initSlider.bind(this))
    window.addEventListener('shopify:section:load', this.initSlider.bind(this))
    this.cards = this.querySelectorAll('.pdp-brewing-card')
    this.cards.forEach((card) => this.openBrewingCard(card))
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.initSlider)
    window.removeEventListener('shopify:section:load', this.initSlider)
  }

  initSlider() {
    const slider = this.querySelector('.swiper')
    if (!slider) return
    const options = slider.dataset.options && JSON.parse(slider.dataset.options)
    this.swiper = new window.Swiper(
      this.querySelector('.swiper'),
      options || {
        slidesPerView: 1,
        autoplay: {
          delay: parseFloat(this.dataset.autoplay) * 1000 || 5000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        navigation: this.dataset.navigation
          ? {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
          : false,
        loop: this.dataset.loop,
      }
    )
    this.swiper.on('slideChange', () => {
      this.cards.forEach((card) => this.closeBrewingCard(card))
    })
    if (this.dataset.custom) window[this.dataset.custom] = this.swiper
  }

  openBrewingCard(card) {
    const button = card.querySelector('[data-target="brewing-card"]')
    button.addEventListener('click', () => {
      card.setAttribute('open', '')
    })
  }

  closeBrewingCard(card) {
    card.removeAttribute('open')
  }
}

customElements.define('pdp-brewing-guide', BrewingGuide)
